import React from 'react';
import NumericInput, { NumericInputProps } from '../NumericInput';

export type AppCurrencyInputProps = Omit<NumericInputProps, 'thousandSeparator'>;

/**
 * Money input. Sanitised numeric text field (strips £/commas/spaces, flags
 * malformed values inline) that formats with thousand separators on blur
 * ("1500" → "1,500.00"). Pass `prefix` for a currency symbol where the screen
 * shows one. Commits the cleaned numeric string to the form.
 */
const AppCurrencyInput: React.FC<AppCurrencyInputProps> = (props) => (
  <NumericInput {...props} thousandSeparator />
);

export default AppCurrencyInput;
